export const scoreDetailsOrder = [
  'crystals',
  'crystal-else',
  'phase Separation',
  'other',
  'precipitate',
  'clear',
  'contaminants',
];

export const morphologyDetailsOrder = [
  '3D',
  'rods',
  'plate',
  'needle',
  'micro',
  'spherulite',
];
